import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { BreakpointObserver } from '@angular/cdk/layout';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { tap, first, mergeMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { User, IUser } from '../../core/users/users.model';

@Component({
  selector: 'app-lista-utenti',
  templateUrl: './lista-utenti.component.html',
  styleUrls: ['./lista-utenti.component.scss']
})
export class ListaUtentiComponent implements OnInit {
  displayedColumns: string[];
  dataSource: MatTableDataSource<IUser>;
  columnDefinitions = {
    mobile: ['user_name', 'area'],
    desktop: ['user_name', 'area', 'authorization']
  };
  current_lang = 'it';

  @select(['user', 'list'])
  user_list$: Observable<any>;
  user_list: User[] = [];
  @select(['logged', 'logged'])
  user_logged$: Observable<any>;
  user_logged: User;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private titleService: Title,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService
    ) {
      this.translate.setDefaultLang('it');
      if (this.translate.currentLang) {
        this.current_lang = this.translate.currentLang;
        this.translate.use(this.current_lang);
      } else {
        this.translate.use('it');
        this.current_lang = this.translate.currentLang;
      }
      this.translate.get('breadcrumb.admin_user').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
      this.translate.onLangChange.subscribe(() => {
        this.translate.get('breadcrumb.admin_user').subscribe((res: string) => {
          this.titleService.setTitle(res + ' - PRIMIS');
        });
        this.changeLangFunction();
      });
    }

  ngOnInit(): void {
    this.user_logged$.pipe(
      first(),
      mergeMap((user) => {
        this.user_logged = user;
        return this.user_list$.pipe(first());
      }),
      tap((list) => {
        if (this.user_logged.auth_user === 'superadmin') {
          this.dataSource = new MatTableDataSource(list);
        } else {
          this.dataSource = new MatTableDataSource(
            list.filter(({geopos}) => geopos[0].id === this.user_logged.geopos[0].id)
          );
        }
      })
    ).subscribe(() => this.dataSource.paginator = this.paginator);

    this.breakpointObserver.observe('(max-width: 800px)').subscribe(result => {
      if (result.matches) {
        this.displayedColumns = this.columnDefinitions.mobile;
      } else {
        this.displayedColumns = this.columnDefinitions.desktop;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource && this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.translate.get('admin_user.paginator').subscribe(translation => {
      this.paginator._intl.itemsPerPageLabel = translation.items_per_page;
      this.paginator._intl.nextPageLabel = translation.next;
      this.paginator._intl.previousPageLabel = translation.prev;
      this.paginator._intl.getRangeLabel = function(page, pageSize, length) {
        const of = translation.elem_of_tot;
        if (length === 0 || pageSize === 0) {
          return '0 ' + of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
      };
    });
  }

}
